import { Component, OnInit } from '@angular/core';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { Parent } from 'src/app/models/parents-section.model';
import { AuthService } from 'src/app/services/auth.service';
import { ParentsService } from 'src/app/services/parents-section.service';
import { DlaRodzicowModalComponent } from './modal/dla-rodzicow-modal/dla-rodzicow-modal.component';
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { SelectedSchool } from 'src/app/enum/selected-school';
import { SelectSchoolService } from 'src/app/services/select-school.service';

@Component({
  selector: 'app-dla-rodzicow',
  templateUrl: './dla-rodzicow.component.html',
  styleUrls: ['./dla-rodzicow.component.sass']
})
export class DlaRodzicowComponent implements OnInit {


  modalRef?: MdbModalRef<DlaRodzicowModalComponent>;

  public parents: Parent[] = []
  selectedSchool: SelectedSchool;
  dbPath: string;

  constructor(
    private parentService: ParentsService, 
    private authService: AuthService, 
    private modalService: MdbModalService,
    private selectSchoolService: SelectSchoolService) {
      this.selectedSchool = this.selectSchoolService.getSchool();
      this.dbPath = 'Parents_' + this.selectedSchool;
    }

  ngOnInit(): void {
    console.log('DlaRodzicowComponent ngOnInit - selectedSchool:', this.selectedSchool);
    this.parentService.getAllParents().subscribe(data => {
      console.log('Received parents data:', data);
      data.forEach(parent => {
        console.log('Parent:', parent, 'fileName:', parent.fileName, 'has fileName:', !!parent.fileName);
      });
      let priorityParents = data.filter(x => x.important === true);
      const notPriorityParents = data.filter(x => !x.important);
      this.parents = priorityParents.concat(notPriorityParents);
      console.log('Filtered parents:', this.parents);
      this.parents.forEach(parent => {
        console.log('Display parent:', parent, 'fileName:', parent.fileName);
      });
    }, error => {
      console.error('Error loading parents:', error);
    });
  }

  GetActiveUser(): boolean{
    if(this.authService.GetActiveUser() !== null) return true
    return false
  }

  navigateToLogout(): void {
    this.authService.SignOut();
  }

  openModalEdit(parentToEdit: Parent) {
    this.modalRef = this.modalService.open(DlaRodzicowModalComponent, {
      data: {
        operation: 'Edit',
        parentToEdit: parentToEdit
      },
      backdrop: true,
      ignoreBackdropClick: true
    });
  }

  displayName(){
    let user = this.authService.GetActiveUser();
    return user.displayName;
  }

  openModal() {
    this.modalRef = this.modalService.open(DlaRodzicowModalComponent, {
      backdrop: true,
      ignoreBackdropClick: true
    });
  }

  deleteParent(parent: Parent): void{
    if(parent.fileName) {
      this.parentService.deleteFileStorage(parent.fileName);
    }
    if(parent.id) {
      this.parentService.deleteParent(parent);
    }
  }

  downloadFile(parent: Parent): void {
    if (!parent.fileName) {
      console.error('No fileName for parent:', parent);
      return;
    }
    console.log('Downloading file:', parent.fileName, 'from path:', this.dbPath);
    const storage = getStorage();
    getDownloadURL(ref(storage, `${this.dbPath}/${parent.fileName}`))
      .then((url) => {
        console.log('Got download URL:', url);
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = function() {
          var a = document.createElement('a');
          a.href = window.URL.createObjectURL(xhr.response);
          a.download = parent.fileName || 'plik';
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
        xhr.open('GET', url);
        xhr.send();
      })
      .catch((error) => {
        console.error('Błąd pobierania pliku:', error);
        alert('Nie można pobrać pliku. Sprawdź konsolę przeglądarki.');
      });
  }
}
